<app-titledescription [title]="'Competencias'" [description]="'Aca se muestra competencias del titulo seleccionado'"></app-titledescription>
<!-- <ng-template #filterTitulo>
</ng-template> -->
<div class="grid lg:grid-cols-2 gap-2">
    <mat-form-field class="example-full-width">
      <mat-label>Seleccionar Título</mat-label>
      <input matInput type="text" [matAutocomplete]="autoTitulo" [(ngModel)]="tituloInputText" (ngModelChange)="filtrarTitulos($event)">
      <mat-autocomplete #autoTitulo="matAutocomplete" (optionSelected)="onTituloSelected($event)">
        <mat-option *ngFor="let titulo of titulosFiltrados" [value]="titulo.label">
          {{ titulo.label }}
        </mat-option>
      </mat-autocomplete>
    </mat-form-field>
    <!-- <app-select [data]="dataSelectNiveles" [disabled]="!this.tituloSelected" [label]="'Seleccionar Nivel'"
      [(value)]="nivelSelected" (selectValue)="selectValueNivel($event)"></app-select> -->
    <app-autocomplete-field
          [label]="'Seleccione Nivel'"
          [placeholder]="'Escribe para buscar...'"
          [options]="dataSelectNiveles"
          (optionSelected)="selectValueNivel($event)">
        </app-autocomplete-field>
      @if(tituloSelected && nivelSelected && dataFetch.data.length > 0){
        <div class="flex items-center mb-2" >
          <app-button
            [text]="'Descargar PDF'"
            [typeButton]="'button'"
            (click)="downloadCompetenciasNivelPDF()"
            color="warn"
            [isDisabled]="isLoadingPDFFn()"
            [tooltip]="'Competencias del nivel y titulo seleccionado'"
          ></app-button>
          <span *ngIf="isLoadingPDFFn()" class="ml-2 align-middle">
            <mat-progress-spinner diameter="24" mode="indeterminate"></mat-progress-spinner>
          </span>
        </div>
      }
</div>
<ng-template #tableCompetencias>
  <div [ngClass]="!tituloSelected ? 'pointer-events-none opacity-25 cursor-not-allowed' : ''">
    <app-table
      [height]="'550px'"
      [columnsNames]="columnNamesCompetencias"
      [dataFetch]="tituloSelected ? dataFetch : {data:[],total_items:0}"
      [totalItems]="totalItems"
      (fetchAgain)="fetchData($event.options, $event.ignoreCache)"
      [filterable]="true"
      [labelSelect]="'Seleccione Titulo'"
      [labelFilter]="'Descripcion'"
      [apiService]="apiService"
      [pageIndex]="pageIndex"
    >
    </app-table>
  </div>
</ng-template>
<app-card
[templateRefContent]="tableCompetencias"></app-card>
